<template>
  <div class="main-menu">
    <ul class="main-menu__list">
      <menu-item class="main-menu__item" v-for="menu in primaryMenus" :key="menu.menuid" :menu="menu" >
        <router-link class="main-menu__link" :to="menu.url" v-if="menu.linktype === 'URL'">
          {{ menu.menuname }}
        </router-link>
        <a href="javascript:void(0)" class="main-menu__link" v-else-if="menu.linktype === 'TXT'">
          {{ menu.menuname }}
          <svg width="7px" height="5px">
              <path d="M0.280,0.282 C0.645,-0.084 1.238,-0.077 1.596,0.297 L3.504,2.310 L5.413,0.297 C5.770,-0.077 6.363,-0.084 6.728,0.282 C7.080,0.634 7.088,1.203 6.746,1.565 L3.504,5.007 L0.262,1.565 C-0.080,1.203 -0.072,0.634 0.280,0.282 Z" />
          </svg>
        </a>
        <div class="main-menu__submenu" v-if="menu.hassubmenu === 'Y'">
          <ul class="menu">
            <li v-for="submenu in subMenus(menu.menuid)" :key="submenu.menuid">
              <router-link
                class="menu__link"
                :to="submenu.url"
                v-if="submenu.linktype === 'URL'"
                >{{ submenu.menuname }}</router-link
              >
              <a href="javascript:void(0)"
                class="menu__link"
                v-else-if="submenu.linktype === 'TXT'">
                {{ submenu.menuname }}
              </a>
            </li>
          </ul>
        </div>

        <translator-menu v-if="menu.pgm === 'load_langs'" :countries="countries"></translator-menu>

      </menu-item>

      <!-- <li class="main-menu__item main-menu__item--submenu--menu main-menu__item--has-submenu">
        <a href="javascript:void(0)" class="main-menu__link">
          Translator
          <svg width="7px" height="5px">
              <path d="M0.280,0.282 C0.645,-0.084 1.238,-0.077 1.596,0.297 L3.504,2.310 L5.413,0.297 C5.770,-0.077 6.363,-0.084 6.728,0.282 C7.080,0.634 7.088,1.203 6.746,1.565 L3.504,5.007 L0.262,1.565 C-0.080,1.203 -0.072,0.634 0.280,0.282 Z" />
          </svg>
        </a>
        <translator-menu :countries="countries"></translator-menu>
      </li> -->

    </ul>
  </div>
</template>

<script>
import MenuItem from "./MenuItem.vue";
import TranslatorMenu from "./TranslatorMenu.vue";
import { mapGetters } from 'vuex';

export default {
  components: {
    "menu-item": MenuItem,
    "translator-menu": TranslatorMenu,
  },
  props: {
      menus: {
          type: Array,
          required: true
      },
  },
  data() {
    return {
      searchvalid: true,

      selectedyear: 0,
      selectedmake: null,
      selectedmodel: null,

      countries: [],
    };
  },
  computed: {
    primaryMenus() {
      return this.menus.filter((menu) => {
        if (this.$store.getters['userIsAuthenticated']) {
          return (menu.primary === "Y" && menu.pgm != 'B2C');
        } else {
          return (menu.primary === "Y" && menu.pgm != 'B2B');
        } 
      });
    },
    ...mapGetters([
        'storefrontAttributes',
        'languages'
    ]),
  },
  methods: {
    subMenus(parentMenuId) {
      // console.log('parentMenuId = ' + parentMenuId);
      return this.menus.filter((menu) => {
        if (this.$store.getters['userIsAuthenticated']) {
          return (menu.parentmenuid === parentMenuId && menu.pgm != 'B2C');
        } else {
          return (menu.parentmenuid === parentMenuId && menu.pgm != 'B2B');
        }
      });
    },

    /**
     * setup countries google translate lang
     */
    setupCountries() {
      const languages = this.languages.filter(item => {
        const attr_type = 'G' + item.code.toUpperCase();
        if(this.storefrontAttributes.find(attribute => attribute.type === attr_type).value == 'Y') {
          return true;
        }
      });

      this.countries = [];
      for (const i in languages) {
        const lang = languages[i];
        this.countries.push({
          code : 'en|' + lang.code.toLowerCase(),
          title: lang.description,
        });
      }
    }
  },
  created() {
    this.setupCountries();
  }
};
</script>